<div class="d-flex flex-column justify-content-between vh-88 position-relative">
  <div class="auth-container">
    <img class="mb-5" height="43" width="142" src="assets/monific/logo_monific_v2.svg" alt="" [ngClass]="isWeb ? 'd-block' : 'd-none'">

    <div class="form-container mt-lg-3">

      <div class="pt-3">
        <h4 class="mb-1 fw-bold fs-20 h1-adjust cl-primary text-center">Iniciar sesión</h4>
        <div class="mt-3" *ngIf="existEmail.valid">
          <p class="mb-2 fw-light cl-black fs-17 m-0 text-start"> {{ existEmail?.name }} {{ existEmail?.fatherSurname }} {{ existEmail?.motherSurname }} {{ existEmail?.email }} </p>
          <p class="mt-1 mb-4 cl-black fs-12">¿Estas no son tus iniciales? <span (click)="refresh()" class="fw-bold cl-secondary">Regresar</span></p>
        </div>

      </div>

      <form [formGroup]="loginForm">

        <div class="container">
          <label class="mnf-control mt-4" *ngIf="!existEmail.valid">
            <p class="mnf-control-label cl-primary fs-14 mb-2">Correo electrónico</p>
            <input class="mnf-input-form fs-14" [ngClass]="{ error: email.touched && !email.valid }" formControlName="email"
              placeholder="usuario@correo.com" id="email" type="email" autocomplete="on" name="email">
            <span class="msg-error" *ngIf="email.touched && email.invalid">Es necesario este campo</span>
          </label>

          <div class="text-center mt-1 mb-3" *ngIf="!existEmail.valid">
            <button mat-button class="btn-primary w-100 rounded-4" (click)="verifyEmail()" [disabled]="!loginForm.get('email').valid">Iniciar sesión</button>
          </div>
        </div>

        <div>
          <label class="mnf-control form-password mb-2" *ngIf="existEmail.valid">
            <p class="mnf-control-label cl-primary-3">Contraseña</p>
            <input class="mnf-input-form fw-bold pass fs-16" [type]="passwordFlag" [ngClass]="{ error: password.touched && !password.valid }"
              formControlName="password" placeholder="•••••••••" id="password">
            <i class="mnf-show cr-pointer fs-17" *ngIf="passwordFlag === 'password'" (click)="passwordFlag = 'text'"
              style="top: 55%"></i>
            <i class="mnf-hide cr-pointer fs-19" *ngIf="passwordFlag === 'text'" (click)="passwordFlag = 'password'"
              style="top: 54%"></i>
          </label>

          <div class="text-right cl-primary fs-12 cr-pointer" *ngIf="existEmail.valid">
            <a class="cl-secondary" (click)="forgotPassword()">Olvide mi contraseña</a>
          </div>

          <div class="text-center mt-3 mb-3" *ngIf="existEmail.valid">
            <button mat-button class="btn-primary w-100 rounded-4" (click)="login()">Iniciar sesión</button>
          </div>
        </div>
      </form>
    </div>
    <div class="w-100 px-3 pt-0 form-container bg-white" *ngIf="isSaveCredentials && isNativePlatform">
      <div class="d-flex align-items-center justify-content-center flex-column">
        <div class="d-flex align-items-center my-4 w-100">
          <div class="flex-grow-1 border-bottom"></div>
          <p class="bg-white px-3 mb-0 fs-12">O inicia sesión con</p>
          <div class="flex-grow-1 border-bottom"></div>
        </div>
        <button (click)="loginWithBiometric()" class="auth-button py-2"><img src="assets/icons/auth-icon.svg" width="20" class="me-3" alt="fingerprint-icon">Autenticación Biométrica</button>
      </div>
      <div class="line mt-5"></div>
    </div>

    <div class="new-acount" [ngClass]="{ 'mt-5': isWeb, 'mt-3': isNativePlatform && isSaveCredentials }">
      <p class="fs-14">¿Aún no tienes cuenta?</p>
      <a class="fs-14" routerLink="/registro"><span class="cl-secondary">Regístrate aquí ></span></a>
    </div>

  </div>

  <div class="alert-login my-3" *ngIf="isWeb">
    <p>*Por tu seguridad verifica que la URL de la página es: <a routerLink="/"><span class="cl-third">https://app.monific.com</span></a> </p>
  </div>
</div>

<button *ngIf="!isSaveCredentials" (click)="redirectToProjects()" class="close-login" [ngClass]="{'ios' : isiOSDevice}"><img src="/assets/icon/x.svg" alt="x"></button>